import { Component, ElementRef, HostListener, Input } from '@angular/core';

import { DropdownItemType } from './enums/dropdown-item-type.enum';
import { DropdownItem } from './interfaces/dropdown-item.interface';

@Component({
    selector: 'mapp-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false,
})
export default class DrowpdownComponent {
    @Input() initialText: string;

    @Input() items: DropdownItem[];

    showItems = false;

    type = DropdownItemType;

    /**
     *
     * @param elementRef
     */
    constructor(private elementRef: ElementRef) {}

    /**
     *
     */
    toggleItems() {
        this.showItems = !this.showItems;
    }

    /**
     *
     * @param event
     */
    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.showItems = false;
        }
    }

    /**
     *
     * @param iconName
     */
    getIconPath(iconName: string): string {
        return `/assets/icons/${iconName}.svg`;
    }
}
